import { render, staticRenderFns } from "./Creation.vue?vue&type=template&id=5d1c19a8&"
import script from "./Creation.vue?vue&type=script&lang=js&"
export * from "./Creation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports